<template>
  <div class="flex flex-col items-center">
    <h2 class="text-center text-[20px] xsm:text-[30px] sm:text-[30px] md:text-[30px] lg:text-[50px] font-extrabold tracking-[-1px] leading-[1.2] sm:leading-normal md:leading-[36px] lg:leading-[60px] text-white pb-[10px] xsm:pb-[25px] sm:pb-[25px] md:pb-[25px] lg:pb-[38px] px-[20px]">
      Programmatic, perfected<br/>with the partner who gets you.
    </h2>
    <div
        class="w-[90%] lg:w-full flex flex-col gap-[65px] xsm:gap-[70px] sm:gap-[95px] md:gap-[95px] lg:gap-[193px] bg-white bg-opacity-10 border backdrop-blur-md rounded-[22px] px-[15px] pt-[20px] pb-[70px] sm:px-[30px] sm:pt-[25px] sm:pb-[95px] md:px-[32px] md:pt-[25px] md:pb-[95px] lg:px-[50px] lg:pt-[72px] lg:pb-[187px] text-white relative shadow-xl max-w-[980px] animate__animated animate__fadeIn"
        style="animation-delay: 0.1s;">
      <div v-for="(card, index) in sortedCards" :key="index"
           class="animate__animated animate__fadeIn z-50 relative flex flex-row gap-[25px] rounded-[20px] border-2 border-[#FFFFFF98] px-[10px] xsm:px-[20px] sm:px-[32px] md:px-[20px] lg:px-[32px] pt-[10px] pb-[26px] xsm:pt-[10px] xsm:pb-[26px] sm:pt-[10px] sm:pb-[30px] md:pt-[10px] md:pb-[26px] lg:pt-[38px] lg:pb-[100px]"
           :style="{
              background: 'linear-gradient(180deg, #E69F29 0%, #DC7E1E 100%)',
              animationDelay: `${index * 0.6}s`
            }">
        <div class="relative">
          <div class="flex items-center gap-[10px] xsm:gap-[15px] sm:gap-[25px] px-0 md:px-[32px]">
            <div class="text-[25px] xsm:text-[40px] sm:text-[48px] md:text-[56px] lg:text-[96px] font-extrabold">
              {{ card.percentage }}%
            </div>
            <div class="flex flex-col justify-start">
              <h3 class="font-extrabold text-[18px] xsm:text-[22px] sm:text-[24px] md:text-[24px] lg:text-[40px]">
                {{ card.title }}
              </h3>
              <p class="text-[15px] xsm:text-[18px] sm:text-[18px] md:text-[18px] lg:text-[30px] leading-[16px] md:leading-[22px] lg:leading-normal">
                {{ card.description }}
              </p>
            </div>
          </div>

          <div
              class="z-50 absolute top-[calc(100%+10px)] sm:top-[calc(100%+15px)] md:top-[calc(100%+20px)] w-full flex justify-center">
            <div
                class="max-w-[814px] flex flex-row items-center gap-[10px] sm:gap-[17px] bg-white text-[#2F2F2F] border-2 border-[#E69F29AB] pl-[5px] pr-[10px] py-[10px] xsm:pl-[10px] xsm:pr-[20px] xsm:py-[12px] sm:px-[20px] sm:py-[15px] md:px-[22px] md:py-[16px] lg:px-[35px] lg:py-[26px] rounded-[24px] sm:rounded-full">
              <div class="w-[20px] h-[20px] sm:w-[20px] sm:h-[20px] md:w-[20px] md:h-[20px] lg:w-[40px] lg:h-[40px]">
                <svg
                    class="w-[20px] h-[20px] sm:w-[20px] sm:h-[20px] md:w-[20px] md:h-[20px] lg:w-[40px] lg:h-[40px]"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="19.5" stroke="#E69F29"/>
                  <circle cx="20" cy="20" r="12" fill="#E69F29"/>
                </svg>
              </div>
              <p class="text-[14px] xsm:text-[16px] sm:text-[18px] md:text-[18px] lg:text-[30px] leading-[16px] md:leading-[22px] lg:leading-normal font-bold">
                {{ card.details }}</p>
            </div>
          </div>
        </div>
      </div>

      <img src="../assets/left-celebrate.svg" alt="left-celebrate"
           class="celebrate-icon-left absolute h-[80%] animate__animated animate__zoomInLeft"
           style="animation-delay: 2s;">
      <img src="../assets/right-celebrate.svg" alt="right-celebrate"
           class="celebrate-icon-right absolute h-[80%] animate__animated animate__zoomInLeft"
           style="animation-delay: 2s;">
    </div>
  </div>
</template>


<script>

export default {
  name: "Step6Page",
  props: {
    finalResults: Object,
  },
  data() {
    return {
      cards: [
        {
          percentage: this.finalResults.creativeOptimization,
          id: 'creativeOptimization',
          title: 'Creative Optimization',
          description: "Creativity that stands out from the clutter – that's what you're ready for!",
          details: 'OCM Campaigns include free custom creative design to deliver outstanding results every time.'
        },
        {
          percentage: this.finalResults.contextualTargeting,
          id: 'contextualTargeting',
          title: 'Contextual Targeting',
          description: 'Context is your new keyword — speak to users when it actually matters!',
          details: 'OCM AdSquirrel and Teads Contextual power relevance like never before.'
        },
        {
          percentage: this.finalResults.attentionMeasurement,
          id: 'attentionMeasurement',
          title: 'Attention Measurement',
          description: 'You care about what really matters – attention, not just impressions!',
          details: 'Attention on us … measured in every OCM campaign via Lumen and Adelaide with zero extra cost.'
        }
      ]
    };
  },
  computed: {
    sortedCards() {
      return this.cards.slice().sort((a, b) => b.percentage - a.percentage);
    }
  }
};
</script>


<style scoped>
.celebrate-icon-right {
  right: -5%;
}

.celebrate-icon-left {
  left: -5%;
}

.celebrate-icon-right, .celebrate-icon-left {
  top: 15%;
}
</style>




